import axios from 'axios';
import {
  INITIALIZE_APP,
  ADD_TO_SCENE,
  SET_DATASOURCE,
  ADD_TO_SCENE_BULK,
  ADD_PAGE,
  SET_PAGE_STATE,
  ADD_TO_DRAG_ELEMENTS,
  ADD_TO_DRAG_ELEMENTS_ALL,
  REMOVE_ALL_DRAG_ELEMENTS,
  REMOVE_DRAG_ELEMENTS,
  MAKE_ELEMENT_ACTIVE,
  CHANGE_PROPERTIES,
  CHANGE_PROPERTIES_BY_ID,
  CHANGE_PROPERTIES_BY_ID2,
  CHANGE_PROPERTIES_BY_ID3,
  CHANGE_PROPERTIES_RANGE,
  DROP_ELEMENT,
  DROP_ELEMENT_ALL,
  DROP_ELEMENT_BULK,
  DOUBLE_CLICK,
  UPDATE_ELEMENT
} from './types';
/**
 * Apply loaded settings to application
 *
 * @param {object} settings
 */
export const initializeApp = settings => ({
  type: INITIALIZE_APP,
  payload: settings
});
/**
 * Loads settings from a JSON
 */
export const loadSettings = () => async dispatch => {
  const res = await axios.get('./settings.json');
  const data = await res.data;
  dispatch(initializeApp(data));
};
/**
 * Adds dropped element to scene
 *
 * @param {object} object
 */
 export const setDatasource = (ds) => (
  {
    type: SET_DATASOURCE,
    payload: {
      ds 
    }
  });
export const addToScene = (id, object) => (
  {
    type: ADD_TO_SCENE,
    payload: {
      id,
      object
    }
  });
  export const addToSceneBulk = (loadObjects) => (
    {
      type: ADD_TO_SCENE_BULK,
      payload: {
        loadObjects 
      }
    });
export const addPage = (id, Width, Height) => (
  {
    type: ADD_PAGE,
    payload: {
      id,
      Width,
      Height
    }
  });
export const setPageState = (st) => (
  {
    type: SET_PAGE_STATE,
    payload: st
  });
export const addToDragElements = (id) => (
  {
    type: ADD_TO_DRAG_ELEMENTS,
    payload: {
      id
    }
  });
  export const addToDragElementsAll = (pageid,e) => (
    {
      type: ADD_TO_DRAG_ELEMENTS_ALL,
      payload: {
        pageid,
        e
      }
    });  
export const removeAllDragElements = () => (
  {
    type: REMOVE_ALL_DRAG_ELEMENTS
  });
export const removeDragElements = (elementId) => (
  {
    type: REMOVE_DRAG_ELEMENTS,
    payload: elementId
  });
/**
 * Makes active to clicked element and disable others.
 *
 * @param {string} elementId
 */
export const makeElementActive = elementId => ({
  type: MAKE_ELEMENT_ACTIVE,
  payload: elementId
});
/**
 * Updates selected elements location.
 *
 * @param {string} elementId
 * @param {object} props
 */
export const changeProperties = location => ({
  type: CHANGE_PROPERTIES,
  payload: location
});
export const changePropertiesById = (id, newProperties) => ({
  type: CHANGE_PROPERTIES_BY_ID,
  payload: {
    id,
    newProperties
  }
});
export const changePropertiesById2 = (id, newProperties) => ({
  type: CHANGE_PROPERTIES_BY_ID2,
  payload: {
    id,
    newProperties
  }
});
export const changePropertiesById3 = (id, newProperties) => ({
  type: CHANGE_PROPERTIES_BY_ID3,
  payload: {
    id,
    newProperties
  }
});
export const changePropertiesRange = (objs, newProperties) => ({
  type: CHANGE_PROPERTIES_RANGE,
  payload: {
    objs,
    newProperties
  }
});
/**
 * Updates selected elements location.
 *
 * @param {string} elementId
 * @param {object} props
 */
export const dropElement = elementId => ({
  type: DROP_ELEMENT,
  payload: elementId
});
export const dropElementAll = elementId =>  ({
  type: DROP_ELEMENT_ALL,
  payload: elementId
});
export const dropElementBulk = objs => ({
  type: DROP_ELEMENT_BULK,
  payload: objs
});
export const doubleClick = elementId => ({
  type: DOUBLE_CLICK,
  payload: elementId
});
export const updateElement = elementId => ({
  type: UPDATE_ELEMENT,
  payload: elementId
});
